/**
 * @author        yontaek@zumper.com (Yon Taek Chung)
 * @copyright     Copyright (c) 2023, Zumper
 */

export const getRatingScoreText = (rating: number) => {
  if (rating >= 9) {
    return 'Excellent'
  } else if (rating >= 7) {
    return 'Very good'
  } else if (rating >= 4) {
    return 'Good'
  } else {
    return 'Poor'
  }
}

export const getReviewerName = (name: string) => {
  const [firstName, lastName] = name.split(' ')
  if (!firstName && !lastName) return ''

  if (firstName && lastName) {
    return `${firstName} ${lastName.charAt(0)}.`
  }

  return firstName
}
